import { useState } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Token de um link de convite ou de redefinição de senha (ADR-056). Os links novos o levam depois
 * do `#` — o navegador não envia essa parte ao servidor, então ela não cai em log de acesso —; os
 * antigos, no caminho (`/convite/<token>`), que continua valendo até o link vencer. Lido uma vez,
 * o token sai da barra de endereço: não fica no histórico, nem em print da tela.
 */
export function useLinkToken(): string {
  const { token: fromPath } = useParams();
  const [token] = useState(() => {
    const fromHash = window.location.hash.slice(1);
    const value = fromHash || fromPath || '';
    if (value) {
      // Sem o token: o `#` inteiro, ou o último trecho do caminho nos links antigos.
      const path = fromPath
        ? window.location.pathname.replace(/\/[^/]*$/, '')
        : window.location.pathname;
      window.history.replaceState(window.history.state, '', path);
    }
    return value;
  });
  return token;
}
